import { Model } from "@/models/base/model";

export class UserArticleFavorite extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // // コンテンツ記事お気に入り更新
  async updateUserArticleFavorites(articleId: number): Promise<any> {
    this.url = "/cms/api/users/article-favorites/update";
    return await this.save({ articleId }, "POST");
  }
}
